// Horario de las categorías POS (hora_desde / hora_hasta, módulo pos_product_sets de Odoo).
// Fuera de su horario, la categoría, sus subcategorías y sus productos no se muestran.
// Se usa la hora del equipo: los horarios vienen con las categorías al iniciar sesión, así
// que funciona sin internet. 00:00 = sin límite. Ej. desayunos: 00:00 a 12:00.
import { useEffect, useState } from 'react';

const np = (p) => (Array.isArray(p) ? (p[0] ?? null) : (p ?? null));

export const minutoDelDia = (fecha = new Date()) => fecha.getHours() * 60 + fecha.getMinutes();

function enHorario(cat, minuto) {
    const desde = Math.round((Number(cat?.hora_desde) || 0) * 60);
    const hasta = Math.round((Number(cat?.hora_hasta) || 0) * 60);
    if (!desde && !hasta) return true;                       // sin horario
    if (!hasta) return minuto >= desde;                      // solo "desde"
    if (desde <= hasta) return minuto >= desde && minuto < hasta;
    return minuto >= desde || minuto < hasta;                // cruza la medianoche (ej. 20:00 a 03:00)
}

// Ids de las categorías que no se muestran ahora: las que están fuera de horario, las que cuelgan
// de una que lo está, y las que tenían subcategorías y se quedaron sin ninguna visible.
export function categoriasOcultas(cats = [], minuto = minutoDelDia()) {
    const porId = new Map(cats.map((c) => [c.id, c]));
    const ocultas = new Set();
    for (const c of cats) {
        let n = c;
        for (let i = 0; n && i < 20; i++) {
            if (!enHorario(n, minuto)) { ocultas.add(c.id); break; }
            n = porId.get(np(n.parent_id));
        }
    }
    let cambio = true;
    while (cambio) {
        cambio = false;
        for (const c of cats) {
            if (ocultas.has(c.id)) continue;
            const hijas = cats.filter((h) => np(h.parent_id) === c.id);
            if (hijas.length > 0 && hijas.every((h) => ocultas.has(h.id))) {
                ocultas.add(c.id);
                cambio = true;
            }
        }
    }
    return ocultas;
}

// Minuto del día que se actualiza solo: la pantalla se vuelve a calcular apenas cambia el minuto
// (a las 12:00 los desayunos desaparecen sin recargar).
export function useMinutoDelDia() {
    const [minuto, setMinuto] = useState(() => minutoDelDia());
    useEffect(() => {
        const t = setInterval(() => setMinuto(minutoDelDia()), 15000);
        return () => clearInterval(t);
    }, []);
    return minuto;
}
